/* Tienda Novale – cart behaviours (drawer extras, upsells, gifts, discount, terms). */
(function () {
  const TN = (window.TN = window.TN || {});
  if (TN.cart) return;

  const drawer = () => document.querySelector('cart-drawer');

  /* ---------- Cart API ---------- */
  const cart = {
    busy: false,

    sections() {
      const list = [];
      if (drawer()) list.push('cart-drawer', 'cart-icon-bubble');
      return list;
    },

    async request(url, payload) {
      const sections = this.sections();
      const body = Object.assign({}, payload);
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw data;
      return data;
    },

    async state() {
      const response = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      return response.json();
    },

    /* After an add, Shopify returns the added item(s) + sections; fetch the full cart for counts. */
    async render(data, { open = true } = {}) {
      const el = drawer();
      if (el && data.sections) {
        if (data.item_count === undefined) {
          const state = await this.state();
          data.item_count = state.item_count;
        }
        el.renderContents(data, open);
        if (open) el.classList.remove('is-empty');
      } else if (!el) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tn-cart' });
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && el) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tn-cart' });
      }
    },

    async add(items, options = {}) {
      const data = await this.request(window.routes.cart_add_url + '.js', { items });
      await this.render(data, options);
      return data;
    },

    async change(line, quantity, options = {}) {
      const data = await this.request(window.routes.cart_change_url + '.js', { line, quantity });
      await this.render(data, options);
      return data;
    },

    async update(payload, options = {}) {
      const data = await this.request(window.routes.cart_update_url + '.js', payload);
      await this.render(data, options);
      return data;
    },

    async clear(options = {}) {
      const data = await this.request(window.routes.cart_clear_url + '.js', {});
      await this.render(data, options);
      return data;
    },

    /* Cart line (1-based) of a product handle in the drawer, or null. */
    lineOf(handle) {
      const el = drawer();
      const item = el && el.querySelector(`.cart-item--product-${CSS.escape(handle)}`);
      return item ? parseInt(item.dataset.index, 10) : null;
    },

    /* Runs cart operations one at a time. */
    async queue(fn) {
      if (this.busy) return null;
      this.busy = true;
      try {
        return await fn();
      } catch (e) {
        console.error(e);
        return null;
      } finally {
        this.busy = false;
      }
    },
  };
  TN.cart = cart;

  const optedOutKey = 'tn-upsell-opted-out';
  const optedOut = () => {
    try {
      return JSON.parse(sessionStorage.getItem(optedOutKey) || '[]');
    } catch (e) {
      return [];
    }
  };
  const setOptedOut = (handle, value) => {
    const list = optedOut().filter((h) => h !== handle);
    if (value) list.push(handle);
    try {
      sessionStorage.setItem(optedOutKey, JSON.stringify(list));
    } catch (e) {}
  };

  /* ---------- Variant pickers inside upsells / gifts ---------- */
  function readVariants(root) {
    const script = root.querySelector('.upsell__variants script[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function currentVariant(root, variants) {
    const selects = Array.from(root.querySelectorAll('.upsell__variants select'));
    const values = selects.map((s) => s.value);
    return variants.find((v) => values.every((value, i) => v.options[i] === value));
  }

  function markUnavailable(root, variants) {
    const selects = Array.from(root.querySelectorAll('.upsell__variants select'));
    selects.forEach((select, index) => {
      Array.from(select.options).forEach((option) => {
        const values = selects.map((s) => s.value);
        values[index] = option.value;
        const match = variants.find((v) => values.every((value, i) => v.options[i] === value));
        option.disabled = !match || !match.available;
      });
    });
  }

  /* ---------- <tn-upsell> ---------- */
  class TnUpsell extends HTMLElement {
    connectedCallback() {
      this.variants = readVariants(this);
      if (this.variants.length) {
        if (this.dataset.skipUnavailable === 'true') markUnavailable(this, this.variants);
        this.querySelectorAll('.upsell__variants select').forEach((select) =>
          select.addEventListener('change', () => this.onVariantChange())
        );
      }

      if (this.dataset.toggle === 'true') {
        const trigger = this.classList.contains('upsell--container-toggle') ? this.querySelector('.upsell__container') : this.querySelector('.upsell__toggle');
        if (trigger) {
          trigger.addEventListener('click', (event) => {
            if (event.target.closest('select, a, option')) return;
            event.preventDefault();
            this.toggle();
          });
        }
      } else {
        const button = this.querySelector('.upsell__add');
        if (button) button.addEventListener('click', () => this.addNow(button));
      }
    }

    get selected() {
      return this.dataset.selected === 'true';
    }

    set selected(value) {
      this.dataset.selected = value ? 'true' : 'false';
      const toggle = this.querySelector('.upsell__toggle');
      if (toggle) toggle.setAttribute('aria-pressed', value ? 'true' : 'false');
    }

    toggle() {
      const value = !this.selected;
      this.selected = value;
      if (this.dataset.context !== 'cart') {
        this.dispatchEvent(new CustomEvent('upsell:change', { bubbles: true }));
        return;
      }
      setOptedOut(this.dataset.handle, !value);
      this.classList.add('is-loading');
      cart.queue(async () => {
        if (value) {
          await cart.add([{ id: Number(this.dataset.variantId), quantity: 1 }]);
        } else {
          const line = cart.lineOf(this.dataset.handle);
          if (line) await cart.change(line, 0);
        }
      });
    }

    async addNow(button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      const spinner = button.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      await cart.queue(() => cart.add([{ id: Number(this.dataset.variantId), quantity: 1 }]));
      if (!drawer()) window.location = window.routes.cart_url;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }

    onVariantChange() {
      const variant = currentVariant(this, this.variants);
      if (!variant) return;
      const previous = this.dataset.variantId;
      this.dataset.variantId = variant.id;

      if (this.dataset.updatePrices === 'true') {
        const keep = parseFloat(this.dataset.keep || '1');
        const fixed = parseFloat(this.dataset.fixed || '0');
        const price = Math.max(0, Math.round(variant.price * keep - fixed));
        const compare = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        this.querySelectorAll('.upsell__price-regular').forEach((el) => (el.textContent = TN.formatMoney(price)));
        this.querySelectorAll('.upsell__price-compare').forEach((el) => {
          el.textContent = TN.formatMoney(compare);
          el.classList.toggle('hidden', !(compare > price));
        });
      }

      const button = this.querySelector('.upsell__add');
      if (button) button.toggleAttribute('disabled', !variant.available);

      /* In the cart, swap the variant already added. */
      if (this.dataset.context === 'cart' && this.selected && String(previous) !== String(variant.id)) {
        cart.queue(async () => {
          const line = cart.lineOf(this.dataset.handle);
          if (line) await cart.change(line, 0, { open: true });
          await cart.add([{ id: variant.id, quantity: 1 }]);
        });
      }
      this.dispatchEvent(new CustomEvent('upsell:change', { bubbles: true }));
    }
  }
  if (!customElements.get('tn-upsell')) customElements.define('tn-upsell', TnUpsell);

  /* ---------- <tn-gift> ---------- */
  class TnGift extends HTMLElement {
    connectedCallback() {
      this.variants = readVariants(this);
      this.querySelectorAll('.upsell__variants select').forEach((select) =>
        select.addEventListener('change', () => {
          const variant = currentVariant(this, this.variants);
          if (!variant) return;
          this.dataset.variantId = variant.id;
          if (this.dataset.inCart === 'true') {
            cart.queue(async () => {
              const line = cart.lineOf(this.dataset.handle);
              if (line) await cart.change(line, 0);
              await cart.add([{ id: variant.id, quantity: 1 }]);
            });
          }
        })
      );
    }
  }
  if (!customElements.get('tn-gift')) customElements.define('tn-gift', TnGift);

  /* ---------- Keep the cart consistent after every render ---------- */
  function extraHandles(el) {
    const handles = new Set();
    el.querySelectorAll('tn-gift, tn-upsell[data-context="cart"][data-toggle="true"]').forEach((node) =>
      handles.add(node.dataset.handle)
    );
    return handles;
  }

  async function syncCart() {
    const el = drawer();
    if (!el || cart.busy) return;

    const lines = Array.from(el.querySelectorAll('.cart-drawer .cart-item'));
    const extras = extraHandles(el);
    const isExtra = (line) =>
      line.dataset.cartHidden === 'true' ||
      Array.from(extras).some((handle) => line.classList.contains(`cart-item--product-${handle}`));
    const mainLines = lines.filter((line) => !isExtra(line));

    /* Only gifts / toggle upsells / hidden products left: empty the cart. */
    if (lines.length > 0 && mainLines.length === 0) {
      await cart.queue(() => cart.clear({ open: true }));
      return;
    }
    if (mainLines.length === 0) return;

    /* Gifts: add when unlocked, remove when locked. */
    for (const gift of el.querySelectorAll('tn-gift')) {
      const unlocked = gift.dataset.unlocked === 'true';
      const inCart = gift.dataset.inCart === 'true';
      if (unlocked && !inCart) {
        await cart.queue(() => cart.add([{ id: Number(gift.dataset.variantId), quantity: 1 }], { open: true }));
        return;
      }
      if (!unlocked && inCart) {
        const line = cart.lineOf(gift.dataset.handle);
        if (line) await cart.queue(() => cart.change(line, 0, { open: true }));
        return;
      }
    }

    /* Pre-selected toggle upsells join the cart once it has products, unless the shopper removed them. */
    const skipped = optedOut();
    for (const upsell of el.querySelectorAll('tn-upsell[data-context="cart"][data-toggle="true"]')) {
      if (upsell.dataset.preselected === 'true' && upsell.dataset.inCart !== 'true' && !skipped.includes(upsell.dataset.handle)) {
        await cart.queue(() => cart.add([{ id: Number(upsell.dataset.variantId), quantity: 1 }], { open: true }));
        return;
      }
    }
  }
  TN.syncCart = syncCart;

  document.addEventListener('tn:cart-rendered', () => setTimeout(syncCart, 50));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncCart());
  else syncCart();

  /* ---------- Countdown ("cart reserved for mm:ss") ---------- */
  class TnCountdown extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration, 10) || 90;
      this.key = this.dataset.storageKey || 'tn-countdown';
      this.render(this.remaining());
      this.timer = setInterval(() => this.render(this.remaining()), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    remaining() {
      let end = 0;
      try {
        end = parseInt(sessionStorage.getItem(this.key), 10) || 0;
      } catch (e) {}
      const now = Date.now();
      if (!end || end <= now) {
        /* First start uses the configured duration; when it runs out it restarts at 90 seconds. */
        const seconds = end ? 90 : this.duration;
        end = now + seconds * 1000;
        try {
          sessionStorage.setItem(this.key, String(end));
        } catch (e) {}
      }
      return Math.max(0, Math.round((end - now) / 1000));
    }

    render(total) {
      const minutes = String(Math.floor(total / 60)).padStart(2, '0');
      const seconds = String(total % 60).padStart(2, '0');
      this.textContent = `${minutes}:${seconds}`;
    }
  }
  if (!customElements.get('tn-countdown')) customElements.define('tn-countdown', TnCountdown);

  /* ---------- Discount code field ---------- */
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="discount"]');
      this.error = this.querySelector('.cart-discount__error');
      this.input.addEventListener('input', () => this.error.classList.add('hidden'));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    async onSubmit(event) {
      event.preventDefault();
      const code = this.input.value.trim();
      if (!code) {
        this.error.classList.remove('hidden');
        return;
      }
      const button = this.querySelector('.cart-discount__button');
      button.classList.add('loading');
      try {
        const current = await cart.state();
        const codes = (current.discount_codes || []).map((d) => d.code).filter(Boolean);
        if (!codes.includes(code)) codes.push(code);
        await cart.update({ discount: codes.join(',') }, { open: true });
        /* Cart page: totals and discounts live in other sections, reload them all. */
        if (!drawer()) window.location.reload();
      } catch (e) {
        window.location = `/checkout?discount=${encodeURIComponent(code)}`;
      } finally {
        button.classList.remove('loading');
      }
    }
  }
  if (!customElements.get('cart-discount')) customElements.define('cart-discount', CartDiscount);

  /* ---------- Terms & conditions checkbox ---------- */
  const termsKey = 'tn-terms-accepted';
  class TnTerms extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="checkbox"]');
      try {
        this.input.checked = sessionStorage.getItem(termsKey) === 'true';
      } catch (e) {}
      this.input.addEventListener('change', () => {
        try {
          sessionStorage.setItem(termsKey, this.input.checked ? 'true' : 'false');
        } catch (e) {}
        this.hideWarnings();
        this.updateButton();
      });

      this.scope = this.closest('.drawer__inner') || this.closest('form') || document;
      this.onCheckout = (event) => {
        if (this.input.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showWarning();
      };
      this.checkoutButtons().forEach((button) => button.addEventListener('click', this.onCheckout, true));
      this.updateButton();
    }

    checkoutButtons() {
      return Array.from(this.scope.querySelectorAll('[name="checkout"], .shopify-payment-button__button, .additional-checkout-buttons button'));
    }

    updateButton() {
      if (this.dataset.disableButton !== 'true') return;
      this.checkoutButtons().forEach((button) => button.classList.toggle('button--dimmed', !this.input.checked));
    }

    hideWarnings() {
      this.scope.querySelectorAll('.terms-warning').forEach((w) => w.classList.add('hidden'));
    }

    showWarning() {
      const message = this.querySelector('template.terms-checkbox__message');
      const position = this.dataset.warningPosition || 'under-button';
      const target = this.scope.querySelector(`.terms-warning--${position}`) || this.querySelector('.terms-warning');
      if (!target) return;
      target.innerHTML = message ? message.innerHTML : '';
      target.classList.remove('hidden');
    }
  }
  if (!customElements.get('tn-terms')) customElements.define('tn-terms', TnTerms);
})();
